export var FrameStatus;
(function (FrameStatus) {
    FrameStatus["OPENED"] = "opened";
    FrameStatus["CLOSED"] = "closed";
    FrameStatus["MINIMIZED"] = "minimized";
    FrameStatus["MAXIMIZED"] = "maximized";
})(FrameStatus || (FrameStatus = {}));
